import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Logo from '../../Assets/btwb_black.png';
import './Header.css';

const Header = ({ gym }) => (
  <header>
    <Grid className="headerContent" alignItems="center" container>
      <Grid item xs={4}>
        <img
          className="headerLogo contain bg-left"
          src={Logo} alt="Beyond the Whiteboard Logo"
        />
      </Grid>
      {gym && gym.display_name &&
        <>
          <Grid item xs={7}>
            <p className="headerText">{`Welcome, ${gym.display_name}!`}</p>
          </Grid>
          <Grid item xs={1}>
            <img className="gymLogo" alt={`${gym.display_name} logo`} src={gym.image} width="50" height="50" />
          </Grid>
        </>
      }
    </Grid>
  </header>
);

Header.propTypes = {
  gym: PropTypes.object
}

export default Header;